import React, { useState } from 'react'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgetPass = () => {

    const [email, setEmail] = useState('')
    const [message, setMassage] = useState(false)

    const sendLink = async (e) => {
        e.preventDefault();

        const res = await fetch('/sendpasswordlink', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email })
        })

        const data = await res.json()
        console.log(data)
        if (data.status === 201) {
            setMassage(true)
            setEmail('')


        } else {
            toast.error('Invalid user', {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    return (
        <div className='conatiner-fluid signup_container'>
            <div className='row'>

                <div className='col-md-6 col-sm-10 signup_form_left' >
                    <div style={{ fontSize: '1.2rem', color: 'darkgreen' }}>Reset Password</div>
                    <div className="mb-3 mt-3">
                        <label for="uname" className="form-label">Email</label>

                        {message ? <p style={{ color: 'green', fontWeight: 'bold' }}>password reset link send successfully</p> : ''}

                        <input type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control" id="uname" placeholder="Enter Email" name="uname" required />

                    </div>


                    <div className='mb-3 mt-2'>

                        <button
                            onClick={sendLink}
                            style={{ width: '220px' }} type="submit" className="btn btn-primary">send reset link</button>

                        <ToastContainer />
                    </div>

                </div>

                <div className='col-md-6 col-sm-10 signup_form_right'>
                    <img src='../images/reset.jpg' className='img-fluid' />
                </div>

            </div>
        </div>
    )
}

export default ForgetPass;